import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  errorText: {
    color: tokens.colorPaletteRedForeground1,
    fontSize: tokens.fontSizeBase200,
  },
});
